export function formatLargeNumber(value) {
  const abs = Math.abs(value);
  if (abs >= 1_000_000_000_000) {
    return `${Math.floor(value / 1_000_000_000_000 * 10) / 10}T`;
  } else if (abs >= 1_000_000_000) {
    return `${Math.floor(value / 1_000_000_000 * 10) / 10}B`;
  } else if (abs >= 1_000_000) {
    return `${Math.floor(value / 1_000_000 * 10) / 10}M`;
  } else if (abs >= 1_000) {
    return `${Math.floor(value / 1_000 * 10) / 10}K`;
  } else {
    return value.toString();
  }
}

export function formatPercentageChange(value, needSign) {
  if (value === 0) return '0.000%';
  const absValue = Math.abs(value).toFixed(3);
  if (!needSign) return `${absValue}%`;
  const sign = value > 0 ? '+' : '-'
  return `${sign}${absValue}%`;
}

export function formatPrice(value) {
  if (value === null || value === undefined || isNaN(value)) return '--';
  const abs = Math.abs(value);
  if (abs >= 1) {
    // For values 1 or greater, show 2 decimal places
    return `${value.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  } else if (abs >= 0.01) {
    // For 0.01 ≤ value < 1, show up to 4 decimals
    return `${value.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 4
    })}`;
  } else if (abs === 0) {
    return `${value.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  } else {
    // For tiny values < 0.01, show up to 6–8 decimals
    return `${value.toLocaleString(undefined, {
      minimumFractionDigits: 4,
      maximumFractionDigits: 8
    })}`;
  }
}

export function stripChainName(name) {
  return name.replace(/\s*\(.*?\)$/, '').trim();
}